import {
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

const InterventionAddressForm = ({ register }) => {
  const { t } = useTranslation();

  return (
    <Grid
      gap={"8px"}
      templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(4, 1fr)" }}
      templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(2, 1fr)" }}
    >
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"streetNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.streetNumber.title</Trans>
          </FormLabel>
          <Input
            id={"streetNumber"}
            placeholder={t("beneficiaryFile.form.streetNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("streetNumber")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 3 }} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"streetName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.streetName.title</Trans>
          </FormLabel>
          <Input
            id={"streetName"}
            placeholder={t("beneficiaryFile.form.streetName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("streetName")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"interventionPostalCode"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.interventionPostalCode.title</Trans>
          </FormLabel>
          <Input
            id={"interventionPostalCode"}
            placeholder={t(
              "beneficiaryFile.form.interventionPostalCode.placeholder",
            )}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("interventionPostalCode")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"interventionCity"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.interventionCity.title</Trans>
          </FormLabel>
          <Input
            id={"interventionCity"}
            placeholder={t("beneficiaryFile.form.interventionCity.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("interventionCity")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"interventionCountry"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.interventionCountry.title</Trans>
          </FormLabel>
          <Input
            id={"interventionCountry"}
            placeholder={t(
              "beneficiaryFile.form.interventionCountry.placeholder",
            )}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("interventionCountry")}
          />
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default InterventionAddressForm;
